import React, {useState} from "react";
import EventList from "../components/EventList";
import AddEventModal from "../components/AddEventModal";
import {useNavigate, useParams} from "react-router-dom";
import Sidebar from "../components/Sidebar";

const EventManagement = () => {
    const {tourId, tourName} = useParams();
    const decodedTourName = decodeURIComponent(tourName);
    const firstName = localStorage.getItem("firstName");
    const [showAddModal, setShowAddModal] = useState(false);
    const [refreshList, setRefreshList] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const navigate = useNavigate();

    const handleLogout = (event) => {
        event.preventDefault(); // Prevent default link/button behavior if necessary
        console.log("Navigating to /login...");
        // Clear session storage
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        localStorage.removeItem("universityId");
        console.log("Logging out...");
        // Redirect to login page
        navigate("/login");
    };
    const handleSaveEvent = () => {
        setRefreshList((prev) => !prev); // Trigger list refresh
        setSelectedEvent(null); // Clear selected event after save
    };

    const handleEditEvent = (event) => {
        setSelectedEvent(event); // Set the selected event for editing
        setShowAddModal(true);
    };

    return (
        <div className="dashboard">
            <Sidebar/>

            <main className="main-content">
                <header className="header component">
                    <span className="component-header">{decodedTourName}</span><br/>

                    <button
                        className="btn btn-primary action"
                        onClick={() => {
                            setSelectedEvent(null); // Clear selected event for new event
                            setShowAddModal(true);
                        }}
                    >
                        <i className="fa fa-plus"></i> New Event
                    </button>
                </header>
                <p><a href="/dashboard"> Home </a> > <a href="/tours"> Tours </a> >  {decodedTourName}</p>
                <hr/>


                <EventList
                    tourId={tourId}
                    tourName={tourName}
                    refreshKey={refreshList}
                    onEdit={handleEditEvent}
                />
                {showAddModal && (
                    <AddEventModal
                        tourId={tourId}
                        event={selectedEvent}
                        onClose={() => setShowAddModal(false)}
                        onSave={handleSaveEvent}
                    />
                )}
            </main>

        </div>

    )
        ;
};

export default EventManagement;